import createHeaders from "@utils/createHeaders";
import { dataQrType } from "../../store/params";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Aggregator Name', value: 'aggregator_name' },
  { text: 'Merchant Name', value: 'merchant_name' },
  { text: 'MID', value: 'mid' },
  { text: 'Client ID', value: 'client_id' },
  { text: 'Merchant Type', value: 'merchant_type' },
  { text: 'Versi Client', value: 'client_type' },
  { text: 'Tanggal Dibuat', value: 'created_date' },
  { text: 'Action', value: 'action', width: '100' },
]);

export const detailHeaders = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Merchant Name', value: 'merchant_name' },
  { text: 'MID', value: 'mid' },
  { text: 'NMID', value: 'nmid' },
  { text: 'No Handphone', value: 'mobile_phone' },
  { text: 'Jenis QR', value: 'qr_type' },
]);

export const filterData = [
  { label: 'Merchant Name', field: 'merchant_name', type: 'text' },
  { label: 'MID', field: 'mid', type: 'text' },
  { label: 'NMID', field: 'nmid', type: 'text' },
  { label: 'No Handphone', field: 'mobile_phone', type: 'text' },
  { label: 'Jenis QR', field: 'qr_type', type: 'select', items: dataQrType },

];

export const search = {
  merchant_type: '',
  mid: '',
  client_type: '',
  created_date: [],
  aggregator_name: '',
};

export const searchDetail = {
  merchant_name: '',
  mid: '',
  nmid: '',
  mobile_phone: '',
  qr_type: '',
};

export const merchantType = [
  { value: '1', text: 'Merchant' },
  { value: '3', text: 'Submerchant' },
];
export const clientType = [
  { value: '1', text: 'Non SNAP' },
  { value: '2', text: 'SNAP' },
];

export const CLIENT_TYPE = {
  SNAP: 'Snap',
  NON_SNAP: 'Non-Snap',
};

export const CLIENT_TYPE_VALUE = {
  SNAP: '2',
  NON_SNAP: '1',
};
